<script>
export default {
  name: "StepProgress",
  props: {
    steps: {
      type: Number,
      required: true
    },
    labels: {
      type: Array,
      default: () => []
    },
    active: {
      type: Number,
      required: true
    },
    activeClass: {
      type: String,
      default: "step-progress__item--active"
    }
  },
  computed: {
    items() {
      return Array(this.steps).fill(true);
    }
  },
  methods: {
    isPrev(index) {
      return index < this.active;
    },

    isCurrent(index) {
      return index === this.active;
    }
  }
};
</script>

<template>
  <ol class="step-progress">
    <li
      v-for="(item, index) in items"
      :key="index"
      class="step-progress__item"
      :class="{ [activeClass]: isCurrent(index) }"
      :aria-current="isCurrent(index) ? 'step' : null"
    >
      <slot name="label">
        <span v-if="labels[index]" class="sr-only">
          <span v-if="isPrev(index)">{{ $t("stepProgress.previous") }}</span> {{ labels[index] }}
        </span>
      </slot>
    </li>
  </ol>
</template>
